import { flow, pipe } from 'fp-ts/lib/function';
import { chain, map } from 'fp-ts/lib/TaskEither';
import {
  addVersionForUpdate, createAuthorizedDeleteRequest,
  createAuthorizedGetRequest, createAuthorizedHeadRequest,
  createAuthorizedPostRequest, createAuthorizedPutRequest, decode,
  decodeId,
  fetchApi, fetchUnparsedApi,
  setBody, setQuery, Versioned,
} from '@/services/api';
import { intoSendable } from '@/services/api/resources/checklistTemplate/transform';
import { ChecklistTemplateEditable } from '@/ui/DTO';
import {
  encodeListChecklistTemplateQuery,
  checklistTemplateListCodec,
  ListChecklistTemplateQuery,
} from '@/services/api/resources/checklistTemplate';

const baseUrl = '/v2/checklist-templates';
const recordUrl = (id: number): string => `${baseUrl}/${id}`;

export const create = (checklistTemplate: ChecklistTemplateEditable) => pipe(
  baseUrl,
  createAuthorizedPostRequest,
  map(setBody(intoSendable(checklistTemplate))),
  chain(fetchApi),
  chain(decodeId),
);

export const list = (query: ListChecklistTemplateQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodeListChecklistTemplateQuery(query))),
  chain(fetchApi),
  chain(decode(checklistTemplateListCodec)),
);

export const update = (id: number, checklistTemplate: Versioned<ChecklistTemplateEditable>) => pipe(
  id,
  recordUrl,
  createAuthorizedPutRequest,
  map(addVersionForUpdate(checklistTemplate.version)),
  map(setBody(intoSendable(checklistTemplate.data))),
  chain(fetchApi),
);

export const remove = (id: number) => pipe(
  id,
  recordUrl,
  createAuthorizedDeleteRequest,
  chain(fetchApi),
);

export const head = flow(
  recordUrl,
  createAuthorizedHeadRequest,
  chain(fetchUnparsedApi),
);
